import dynamic from 'next/dynamic';

export default dynamic(() => import('./DateTimePickerInternal'), { ssr: false });
